(function () {
    'use strict';

    angular.module("product")
        .controller('ProductImportPricesModalController', ProductImportPricesModalController);

    ProductImportPricesModalController.$inject = ['product', '$uibModalInstance', 'productDataSrvc', 'notificationSrvc', 'errorNotificationSrvc'];

    function ProductImportPricesModalController(product, $uibModalInstance, productDataSrvc, notificationSrvc, errorNotificationSrvc) {
        var self = this;

        self.product = product;
        self.excelFileData = {
            excel_file: null
        };
        self.uploading = false;
        self.imported = false;
        self.unassignedRows = [];
        self.unassignedCols = [{
            title: 'ID',
            value: 'cell',
            type: 'text',
            searchable: false,
            orderable: false
        }, {
            title: 'Nakład',
            value: 'quantity',
            type: 'number',
            searchable: false,
            orderable: false
        }, {
            title: 'Nakład wyświetlany',
            value: 'display_quantity',
            type: 'text',
            searchable: false,
            orderable: false
        }, {
            title: 'Cena nakładu',
            value: 'price',
            type: 'number',
            searchable: false,
            orderable: false
        }, {
            title: 'Dni realizacji',
            value: 'realization_days',
            type: 'number',
            searchable: false,
            orderable: false
        }, {
            title: 'ID opcji',
            value: 'option_id',
            type: 'text',
            searchable: false,
            orderable: false
        }, {
            title: 'Cena opcji',
            value: 'option_price',
            type: 'number',
            searchable: false,
            orderable: false
        }];

        self.ok = ok;
        self.cancel = cancel;

        function ok() {
            if (self.excelFileData.excel_file) {
                self.uploading = true;
                self.imported = false;

                productDataSrvc.importPrices({
                    pk: product.pk
                }, self.excelFileData).$promise.then(
                    function (response) {
                        self.uploading = false;
                        self.unassignedRows = response.unassigned_rows;
                        self.imported = true;
                        // $uibModalInstance.close(self.excelFileData);
                        if (!self.unassignedRows.length) {
                            notificationSrvc.notification("success", 'Import nakładów zakończył się pomyślnie.');
                        }
                    },
                    function (response) {
                        self.uploading = false;
                        self.imported = true;
                        errorNotificationSrvc.displayErrors(response.data);
                    }
                );
            }
        }

        function cancel() {
            if (self.imported) {
                $uibModalInstance.close(self.excelFileData);
            } else {
                $uibModalInstance.dismiss('cancel');
            }
        }
    }
})();
